import { render, staticRenderFns } from "./noPermission.vue?vue&type=template&id=2d5efff0"
import script from "./noPermission.vue?vue&type=script&lang=js"
export * from "./noPermission.vue?vue&type=script&lang=js"
import style0 from "./noPermission.vue?vue&type=style&index=0&id=2d5efff0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports